// VP-206: przy równoległych jobach generowania każdy job dosyła grafiki
// progresywnie — wyniki scalamy po id (update istniejących w miejscu, append
// nowych na końcu), zamiast nadpisywać całą listę, bo joby kasowałyby sobie
// nawzajem wyniki.
export function mergeGraphicsById<T extends { id: string }>(prev: T[], incoming: T[]): T[] {
  const prevIds = new Set(prev.map((g) => g.id));
  const incomingById = new Map(incoming.map((g) => [g.id, g]));
  const updated = prev.map((g) => incomingById.get(g.id) ?? g);
  const appended = incoming.filter((g) => !prevIds.has(g.id));
  // Identity guard: polling dosyła snapshot co ~2s — gdy nic się realnie nie
  // zmieniło (React Query structural sharing zachowuje referencje), zwracamy
  // prev, żeby setState zrobił bailout zamiast re-renderować całą galerię.
  if (appended.length === 0 && updated.every((g, i) => g === prev[i])) return prev;
  return [...updated, ...appended];
}
